import React from "react";
import { withLDProvider } from "launchdarkly-react-client-sdk";

import { LAUNCH_DARKLY_CLIENT_ID } from "api_urls";
import { getPrettyUrl } from "get_base_uri";

import DigitalGiftCardsApp from "components/digital_gift_cards/app";

export default function DigitalGiftCardsLDWrapper(props) {
  const brandPrettyUrl = getPrettyUrl();
  const DigitalGiftCardsLD = withLDProvider({
    clientSideID: LAUNCH_DARKLY_CLIENT_ID,
    user: { kind: "user", key: brandPrettyUrl },
  })(DigitalGiftCardsApp);
  return <DigitalGiftCardsLD {...props} />;
}
